export default __webpack_public_path__ + "static/media/Maisie 9781408309117.cf24d408.jpg";